import {coreApi} from './core'

export const orderService = {
    async getOrders(params) {
        return coreApi.get('order', {params})
    },
    getSearch: async (start, end) => coreApi.get(`order/search?start=${start}&end=${end}`),
    async getOrdersToday() {
        return coreApi.get('order/today')
    },
    async getById(id) {
        return coreApi.get(`order?id=${id}`)
    },
    async getContractsById(id) {
        return coreApi.get(`order/contract?contractId=${id}`)
    },
    async create(data) {
        return coreApi.post(`order`, data)
    },
    async update(data) {
        return coreApi.put(`order`, data)
    }
}